import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";

// مجموعة صلاحيات لوحدة واحدة (hr, acct, ...) مع خيارات تحديد الكل.
export const PermsModuleGroup = ({ module, items, selected, onToggle, onBulk, canDelete, onDeleteCustom }) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const modLabel = t(`perms.modules.${module}`, module);
  const allOn = items.every((it) => selected.includes(it.key));
  const someOn = !allOn && items.some((it) => selected.includes(it.key));

  return (
    <div className="neu p-4" data-testid={`perms-module-${module}`}>
      <div className="mb-3 flex items-center justify-between gap-2">
        <p className="text-sm font-bold text-foreground">{modLabel}</p>
        <NeuButton
          type="button"
          className="!py-1 !px-3 text-[11px]"
          data-testid={`perms-bulk-${module}`}
          onClick={() => onBulk(module, !allOn)}
        >
          {allOn ? t("perms.deselectAll") : someOn ? t("perms.selectAll") : t("perms.selectAll")}
        </NeuButton>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {items.map((it) => {
          const checked = selected.includes(it.key);
          return (
            <label
              key={it.key}
              className={`flex cursor-pointer items-center gap-3 rounded-2xl border px-3 py-2 transition ${
                checked ? "border-primary/40 bg-primary/5" : "border-border/50"
              }`}
              data-testid={`perm-${it.key}`}
            >
              <input
                type="checkbox"
                className="h-4 w-4"
                checked={checked}
                onChange={() => onToggle(it.key)}
              />
              <span className="flex-1 text-xs font-semibold">{isAr ? it.label_ar : it.label_en}</span>
              {it.custom ? (
                <span className="text-[10px] text-muted-foreground">{t("perms.custom")}</span>
              ) : null}
              {it.custom && canDelete ? (
                <button
                  type="button"
                  onClick={(e) => { e.preventDefault(); onDeleteCustom(it.key); }}
                  className="text-[11px] text-destructive"
                  data-testid={`perm-del-${it.key}`}
                >
                  ×
                </button>
              ) : null}
            </label>
          );
        })}
      </div>
    </div>
  );
};
